export const chartColors = {
  stage1: '#00214F',
  stage2: '#910045',
  stage3: '#097B8B',
  stage4: '#F97B00',
  noStage: '#d1d5db',
  productivity: '#004C91',
  effectiveness: '#007D8F'
}
